/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddMessageRequest } from '../models/AddMessageRequest';
import type { ConversationAudioFile } from '../models/ConversationAudioFile';
import type { ConversationCostStatistics } from '../models/ConversationCostStatistics';
import type { ConversationCompleteEvent } from '../models/ConversationCompleteEvent';
import type { ConversationCreateRequest } from '../models/ConversationCreateRequest';
import type { ConversationDto } from '../models/ConversationDto';
import type { ConversationListResponse } from '../models/ConversationListResponse';
import type { ConversationMessageDto } from '../models/ConversationMessageDto';
import type { ConversationSummaryDto } from '../models/ConversationSummaryDto';
import type { ConversationUpdateRequest } from '../models/ConversationUpdateRequest';
import type { MessageDto } from '../models/MessageDto';
import type { MessageMetadataCreateRequest } from '../models/MessageMetadataCreateRequest';
import type { MessageMetadataCreateResponse } from '../models/MessageMetadataCreateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConversationApiService {
  /**
   * @param conversationId
   * @returns ConversationDto Success response
   * @throws ApiError
   */
  public static getConversation(
    conversationId: string
  ): CancelablePromise<ConversationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/internal/messages/conversations/{conversationId}',
      path: {
        conversationId: conversationId,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param conversationId
   * @param title
   * @param endedAt
   * @returns ConversationDto Success response
   * @throws ApiError
   */
  public static updateConversation(
    conversationId: string,
    title: string,
    endedAt: string
  ): CancelablePromise<ConversationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/internal/messages/conversations/{conversationId}',
      path: {
        conversationId: conversationId,
      },
      query: {
        title: title,
        ended_at: endedAt,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param conversationId
   * @param requestBody
   * @returns ConversationDto Success response
   * @throws ApiError
   */
  public static patchConversation(
    conversationId: string,
    requestBody: ConversationUpdateRequest
  ): CancelablePromise<ConversationDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/internal/messages/conversations/{conversationId}',
      path: {
        conversationId: conversationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns MessageDto Success response
   * @throws ApiError
   */
  public static addMessage(
    requestBody: AddMessageRequest
  ): CancelablePromise<MessageDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/internal/messages',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param request
   * @returns MessageMetadataCreateResponse Success response
   * @throws ApiError
   */
  public static addMetadata(
    request: MessageMetadataCreateRequest
  ): CancelablePromise<MessageMetadataCreateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/internal/messages/metadata',
      query: {
        request: request,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns ConversationDto Success response
   * @throws ApiError
   */
  public static createConversation(
    requestBody: ConversationCreateRequest
  ): CancelablePromise<ConversationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/internal/messages/conversations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param event
   * @returns any Success response
   * @throws ApiError
   */
  public static completeConversation(
    event: ConversationCompleteEvent
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/internal/conversations/complete',
      query: {
        event: event,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @param botMasterId
   * @param startedAt
   * @param endedAt
   * @param completedConversations
   * @param conversationId
   * @param userId
   * @param userName
   * @param agentId
   * @param agentTitle
   * @param agentName
   * @param mode
   * @param countries
   * @param channel
   * @param lessThen
   * @param moreThen
   * @param page Zero-based page index (0..N)
   * @param size The size of the page to be returned
   * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns ConversationListResponse OK
   * @throws ApiError
   */
  public static getConversations(
    xAiAgentOrganizationContext: string,
    botMasterId?: string,
    startedAt?: string,
    endedAt?: string,
    completedConversations?: boolean,
    conversationId?: string,
    userId?: string,
    userName?: string,
    agentId?: string,
    agentTitle?: string,
    agentName?: string,
    mode?: 'INCLUDE' | 'EXCLUDE',
    countries?: Array<string>,
    channel?: string,
    lessThen?: number,
    moreThen?: number,
    page?: number,
    size: number = 100,
    sort?: Array<string>,
    metricName?: string,
    metricValue?: string | string[]
  ): CancelablePromise<ConversationListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/messages/conversations',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        bot_master_id: botMasterId,
        started_at: startedAt,
        ended_at: endedAt,
        completed_conversations: completedConversations,
        conversation_id: conversationId,
        user_id: userId,
        user_name: userName,
        agent_id: agentId,
        agent_title: agentTitle,
        agent_name: agentName,
        mode: mode,
        countries: countries,
        channel: channel,
        less_then: lessThen,
        more_then: moreThen,
        page: page,
        size: size,
        sort: sort,
        metric_name: metricName,
        metric_value: metricValue,
      },
    });
  }
  /**
   * @param conversationId
   * @param xAiAgentOrganizationContext
   * @returns ConversationDto OK
   * @throws ApiError
   */
  public static getConversation1(
    conversationId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<ConversationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/messages/conversations/{conversationId}',
      path: {
        conversationId: conversationId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @param conversationId
   * @param translationLanguage
   * @returns MessageDto OK
   * @throws ApiError
   */
  public static getMessagesByConversationId(
    xAiAgentOrganizationContext: string,
    conversationId: string,
    translationLanguage?: 'EN'
  ): CancelablePromise<Array<MessageDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/messages/conversations/{conversationId}/messages',
      path: {
        conversationId: conversationId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        translationLanguage: translationLanguage,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @returns string OK
   * @throws ApiError
   */
  public static getConversationCountries(
    xAiAgentOrganizationContext: string
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/messages/conversations/countries',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
    });
  }
  /**
   * @param authorIdentifier
   * @param agentId
   * @param startFrom
   * @returns number Success response
   * @throws ApiError
   */
  public static getMessagesCount(
    authorIdentifier: string,
    agentId: string,
    startFrom: string
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/internal/messages/count',
      query: {
        authorIdentifier: authorIdentifier,
        agentId: agentId,
        startFrom: startFrom,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param participantId
   * @param agentId
   * @param conversationId
   * @param limit
   * @returns ConversationSummaryDto Success response
   * @throws ApiError
   */
  public static getConversationSummaries(
    participantId?: string,
    agentId?: string,
    conversationId?: string,
    limit: number = 100
  ): CancelablePromise<Array<ConversationSummaryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/internal/messages/conversations/summary',
      query: {
        participant_id: participantId,
        agent_id: agentId,
        conversation_id: conversationId,
        limit: limit,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param participantId
   * @param oldestMessageTime
   * @param limit
   * @returns ConversationMessageDto Success response
   * @throws ApiError
   */
  public static getLastConversationMessages(
    participantId: string,
    oldestMessageTime: string,
    limit: number = 100
  ): CancelablePromise<Array<ConversationMessageDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/internal/conversations/last-conversations-messages',
      query: {
        participantId: participantId,
        oldestMessageTime: oldestMessageTime,
        limit: limit,
      },
      errors: {
        400: `Bad request`,
        404: `Not found`,
        500: `Internal server error`,
      },
    });
  }
  /**
   * @param conversationId
   * @returns ConversationAudioFile OK
   * @throws ApiError
   */
  public static getAudioFiles(
    conversationId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<Array<ConversationAudioFile>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/{conversationId}/audio',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      path: {
        conversationId: conversationId,
      },
    });
  }
  /**
   * @param conversationId
   * @returns ConversationAudioFile OK
   * @throws ApiError
   */
  public static getSelfCostStatistics(
    conversationId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<ConversationCostStatistics> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/{conversationId}/self-cost-statistics',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      path: {
        conversationId: conversationId,
      },
    });
  }
}
